import React, { Fragment } from "react";
import { Button } from "antd";

interface Props {
  children: JSX.Element;
  style?: Record<string, unknown>;
  getNextViewName: () => string | null;
  getPreviousViewName: () => string | null;
  cancelEdit?: () => void;

  config: {
    showPrev?: boolean;
    showNext?: boolean;
    showFinish?: boolean;
    showSave?: boolean;
    showCancelEdit?: boolean;
    prev?: () => void;
    save?: () => void;
    next?: () => void;
    finish?: () => void;
  };
}

export function GetViewText(getView: () => string | null): JSX.Element | null {
  const nextView: string | null = getView();
  if (nextView) {
    return <span>({nextView})</span>;
  } else {
    return null;
  }
}

export default class StepContainer extends React.Component<
  Props,
  Record<string, unknown>
> {
  render(): JSX.Element | null {
    const { children, style, config, cancelEdit } = this.props;

    return (
      <Fragment>
        {children}
        <div style={style}>
          <div
            className="steps-action left-align"
            style={{
              marginTop: "30px",
            }}
          >
            {config.showPrev && (
              <Button
                // className="base-button"
                type="primary"
                onClick={config.prev}
                style={{
                  backgroundColor: "#ee4540",
                  color: "white",
                  border: "none",
                  marginRight: "20px",
                }}
              >
                Prev{" "}
                <span
                  style={{
                    marginRight: "2px",
                  }}
                ></span>
                {GetViewText(this.props.getPreviousViewName)}
              </Button>
            )}
            {config.showNext && (
              <Button
                // className="base-button"
                type="primary"
                onClick={config.next}
                style={{
                  marginRight: "20px",
                  backgroundColor: "#52c41a",
                  color: "#ebfffb",
                  border: "none",
                }}
              >
                Next{" "}
                <span
                  style={{
                    marginRight: "2px",
                  }}
                ></span>
                {GetViewText(this.props.getNextViewName)}
              </Button>
            )}
            {config.showFinish && (
              <Button
                type="primary"
                onClick={config.finish}
                style={{
                  marginRight: "20px",
                  backgroundColor: "#52c41a",
                  color: "ebfffb",
                  border: "none",
                }}
              >
                Finish
              </Button>
            )}
            {config.showSave && (
              <Button
                type="primary"
                onClick={config.save}
                style={{
                  marginRight: "20px",
                  position: "relative",
                  // top: "-40px",
                  backgroundColor: "#52c41a",
                  color: "ebfffb",
                  border: "none",
                }}
              >
                Save
              </Button>
            )}
            {config.showCancelEdit && cancelEdit && (
              <Button
                className="base-button"
                onClick={cancelEdit}
                style={{
                  marginRight: "40px",
                }}
              >
                Cancel Edit
              </Button>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
